import { Injectable } from '@angular/core';
import { Subject } from '@shared/rx';
import { IMenuItem } from '@app/xenial-ux/interfaces';

@Injectable()
export class XUXMenuPinnedService {
  public menuObs: Subject<string[]> = new Subject<string[]>();
  private pinnedItems: string[] = [];
  /**
   * get all pinned nav items on load
   */
  public getPinnedMenu(): string[] {
    if (!localStorage.getItem('pinnedMenu')) {
      localStorage.setItem('pinnedMenu', JSON.stringify([]));
    }

    return JSON.parse(localStorage.getItem('pinnedMenu'));
  }

  public removePinnedItems(pinnedItem: string): void {
    const itemKey = pinnedItem;
    const pinnedMenu: string[] = JSON.parse(localStorage.getItem('pinnedMenu'));
    if (!pinnedMenu) {
      localStorage.setItem('pinnedMenu', JSON.stringify([itemKey]));
    } else {
      pinnedMenu.splice(pinnedMenu.indexOf(itemKey), 1);
      localStorage.setItem('pinnedMenu', JSON.stringify(pinnedMenu));
      this.pinnedItems = pinnedMenu;
    }
    this.menuObs.next(this.pinnedItems);
  }

  /**
   * Getting pinned item from localstorage
   */
  public togglePin(menuItem: IMenuItem): void {
    const itemKey = menuItem.title;
    const pinnedMenu: string[] = JSON.parse(localStorage.getItem('pinnedMenu'));
    if (!pinnedMenu) {
      localStorage.setItem('pinnedMenu', JSON.stringify([itemKey]));
    } else {
      if (pinnedMenu.indexOf(itemKey) > -1) {
        menuItem.pinned = false;
        pinnedMenu.splice(pinnedMenu.indexOf(itemKey), 1);
      } else {
        menuItem.pinned = true;
        pinnedMenu.push(itemKey);
      }
      localStorage.setItem('pinnedMenu', JSON.stringify(pinnedMenu));
      this.pinnedItems = pinnedMenu;
    }
    this.menuObs.next(this.pinnedItems);
  }
}
